import React from 'react';
import PropTypes from 'prop-types';
import {
  routes,
  subRoutes,
  pathSearches
} from '../../utils/constants/developerRoutes';
import NavMenu from './NavMenu';

/**
 * DeveloperNavMenu component.
 * @component
 * @param {Object} props - The component props.
 * @param {Function} props.setCollapsed - The set collapsed function.
 * @returns {JSX.Element} - The DeveloperNavMenu component.
 */
export const DeveloperNavMenu = ({ setCollapsed }) => (
  <NavMenu
    setCollapsed={setCollapsed}
    routes={routes}
    subRoutes={subRoutes}
    pathSearches={pathSearches}
  />
);

DeveloperNavMenu.propTypes = {
  setCollapsed: PropTypes.func.isRequired
};
